import styled from 'styled-components';

import { colors } from '../../../core';
import Text, { TextProps } from '../Text';

export interface LinkProps extends TextProps {
  href?: string;
  target?: string;
}

const Link = styled(Text).attrs({
  as: 'a',
  noMargin: true,
})<LinkProps>`
  -webkit-appearance: none;
  background-color: transparent;
  border: 0;
  color: ${({ theme }) => theme.linkColor || colors.primary};
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  transition: 0.4s;

  &:hover {
    color: ${({ theme }) => theme.linkHoverColor || colors.primaryHover};
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &:disabled {
    color: ${({ theme }) => theme.linkDisabledColor || colors.primaryDisabled};
    cursor: default;
  }
`;

export default Link;
